import { Box, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import Iconify from 'src/components/iconify';
import { InvitationRole } from './useInvitationDetails';

/** One tile per granted role: what it is for and what it lets you do. */
export default function InvitationRoleTiles({
  roles,
}: {
  roles: InvitationRole[];
}): JSX.Element {
  return (
    <Box
      component="ul"
      sx={{
        m: 0,
        p: 0,
        listStyle: 'none',
        display: 'grid',
        gap: 1.5,
        gridTemplateColumns: {
          xs: 'minmax(0, 1fr)',
          md: roles.length > 1 ? 'repeat(2, minmax(0, 1fr))' : 'minmax(0, 1fr)',
        },
      }}
    >
      {roles.map((role) => (
        <Stack
          component="li"
          key={role.key}
          gap={2}
          sx={(theme) => ({
            p: 2,
            borderRadius: 2,
            border: `1px solid ${alpha(theme.palette.primary.main, 0.24)}`,
            bgcolor: alpha(theme.palette.primary.lighter, 0.4),
          })}
        >
          <Stack direction="row" alignItems="center" gap={1.5}>
            <Box
              aria-hidden
              sx={{
                width: 44,
                height: 44,
                flexShrink: 0,
                borderRadius: 1.5,
                display: 'grid',
                placeItems: 'center',
                bgcolor: 'text.primary',
                color: 'primary.main',
              }}
            >
              <Iconify icon={role.icon} width={24} />
            </Box>
            <Typography variant="subtitle1">{role.label}</Typography>
          </Stack>
          <Typography variant="body2" color="text.secondary">
            {role.description}
          </Typography>
          {role.perks.length > 0 && (
            <Stack
              component="ul"
              gap={1}
              sx={{ m: 0, p: 0, listStyle: 'none' }}
            >
              {role.perks.map((perk) => (
                <Stack
                  component="li"
                  key={perk}
                  direction="row"
                  alignItems="center"
                  gap={1}
                >
                  <Iconify
                    icon="solar:check-circle-bold"
                    width={18}
                    sx={{ color: 'success.main', flexShrink: 0 }}
                  />
                  <Typography variant="body2">{perk}</Typography>
                </Stack>
              ))}
            </Stack>
          )}
        </Stack>
      ))}
    </Box>
  );
}
